import { HeaderBanner } from 'app/library/experience/models/header-banner.model';
import { IRelevantExperienceQuery } from '../interfaces/relevant-experience.interface';

// @dynamic
export class RelevantExperience {
    id: string;
    name: string;
    backgroundColor: string;
    textColor: string;
    headerBanner: HeaderBanner;
    isDefault: boolean;
    memberCount: number;
    widgetCount: number;

    constructor(query?: IRelevantExperienceQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.backgroundColor = query.background_color;
            this.textColor = query.text_color;
            this.headerBanner = query.header_banner ? new HeaderBanner(query.header_banner) : null;
            this.isDefault = query.is_default;
            this.memberCount = query.member_count;
            this.widgetCount = query.widget_count;
        }
    }
}
